import { IconType } from "react-icons";
import { HiCollection, HiHeart, HiHome, HiPencil } from "react-icons/hi";
import { translate } from "ui/i18n";

export interface SidebarRoute {
  path?: string;
  icon?: IconType;
  name: string;
  children?: { path: string; name: string; icon?: IconType }[];
}

export const sidebarRoutes: SidebarRoute[] = [
  {
    path: "/",
    icon: HiHome,
    name: translate("ns1:Routes.Home"),
  },
  {
    name: translate("ns1:Routes.Library"),
    icon: HiCollection,
    children: [
      {
        path: "/techniques",
        // icon: HiDocument,
        name: translate("ns1:Routes.Techniques"),
      },
      {
        path: "/seances",
        // icon: HiFolderOpen,
        name: translate("ns1:Routes.Seances"),
      },
      {
        path: "/visual-supports",
        name: translate("ns1:Routes.VisualSupports"),
      },
      {
        path: "/tutorials",
        name: translate("ns1:Routes.Tutorials"),
      },
    ],
  },
  {
    path: "/favorites",
    icon: HiHeart,
    name: translate("ns1:Routes.Favorites"),
  },
  {
    path: "/my-creations",
    icon: HiPencil,
    name: translate("ns1:Routes.MyCreations"),
  },
];
